export default __webpack_public_path__ + "static/media/rockpaperscissors.ae20764b.PNG";